export default __webpack_public_path__ + "static/media/star-popup.3841cc83.svg";